import PropTypes from 'prop-types';
import React from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Button from 'yoda-core-components/lib/components/Button';
import classNames from 'classnames/bind';

const cx = classNames.bind('');

/**
 * Given page information, return a valid benefits route.
 * @param {boolean} isCam
 * @param {boolean} isProduction
 */

function MissingPointsBanner(props) {
    const { showMissing } = props;
    return (
        <section
            className={`${cx('sm12', 'md12', 'lg12', 'xl12')} ${dt([
                'sm:!p-0',
                'smOnly:mt-0',
                'smOnly:mx-0',
                'smOnly:pl-5',
            ])}`}
            data-automation-id="missing_points_banner"
        >
            <div
                className={`${cx('missingValueContainer')} ${dt([
                    'sm:!bg-white',
                    'py-4',
                    'mdOnly:flex',
                    'mdOnly:text-center',
                    'smOnly:text-left',
                    'md:!flex',
                    'md:items-center',
                ])}`}
            >
                <div
                    className={`${cx('sm12', 'md9', 'lg9', 'xl9')} ${dt([
                        '!px-0',
                        'smOnly:mb-4',
                        'md:text-left',
                        'text-black',
                    ])}`}
                >
                    <p
                        className={dt(['!mb-1', 'text-large', 'font-semibold'])}
                        data-automation-id="missing_points_header_desc1"
                    >
                        Missing Reward Points?
                    </p>
                    <p
                        className={` ${dt(['mb-0', 'text-normal'])}`}
                        data-automation-id="missing_points_header_desc2"
                    >
                        You can add reward points for your previous in-store purchases.
                    </p>
                </div>
                <div className={`${cx('sm12', 'md3', 'lg3', 'xl3')} ${dt(['!px-0'])}`}>
                    <Button
                        buttonType="Secondary"
                        onClick={showMissing}
                        automationId="add_missing_points_button"
                        className={dt(['w-full'])}
                    >
                        Add Missing Points
                    </Button>
                </div>
            </div>
        </section>
    );
}

MissingPointsBanner.propTypes = {
    showMissing: PropTypes.func.isRequired,
};

export default MissingPointsBanner;
